<template>
    <div class="container-fluid">
        <cph-widget :tabs="tabs"
                    :tab.sync="activeTab"
                    :activeTabName="activeTab.displayName"
                    :tabsByKey="true"
                    :fixed="true"
                    :key="activeTab.displayName"
                    :standOut="true"
                    :closeable="true"
                    :show="templateGroupManagerOpened"
                    :tabKey="'displayName'"
                    @close="templateGroupManagerOpened = false" v-if="templateGroupManagerOpened">
            <h2 slot="header">Template editor</h2>
            <div slot="body">
                <transition name="fade" mode="out-in">
                    <component :is="activeTab.componentName" :passedData="editData" @changeTab="handleTabChange"></component>
                </transition>
            </div>
        </cph-widget>
        <workspace @openTemplateGroupManager="templateGroupManagerOpened = true"></workspace>
    </div>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from 'vuex';
import { TemplatesPerimeter } from '../../../router/perimeters/templatesPerimeter';
import CphWidget from '../../../components/Shared/CphWidget';
import Workspace from '../../../components/Panel/Templates/Workspace/Workspace';
import TemplateGroups from '../../../components/Panel/Templates/TemplateGroups/TemplateGroups';
import Templates from '../../../components/Panel/Templates/TemplatesEditor/Templates';
/**
 * @module Panel/orders
 * @description This component displays all orders and analytics
 * */
export default {
    name: 'TemplatesView',
    perimeters: [TemplatesPerimeter],
    data () {
        return {
            editData: null,
            show: false,
            activeTab: {
                displayName: 'Groups',
                componentName: 'template-groups'
            },
            templateGroupManagerOpened: false
        };
    },
    computed: {
        ...mapGetters({layouts : 'getLayouts', formats: 'getFormats'}),
        tabs () {
            return [
                {
                    displayName: 'Groups',
                    componentName: 'template-groups'
                },
                {
                    displayName: 'Templates',
                    componentName: 'templates'
                }
            ];
        }
    },
    components: {
        Workspace,
        CphWidget,
        Templates,
        TemplateGroups
    },
    methods: {
        ...mapActions([
            'getFormatsListAsync',
            'fetchLayoutsAsync',
            'getAllTemplatesAsync',
            'getTemplateGroupsAsync'
        ]),
        handleTabChange ({name, data}) {
            let groupToSet = name === 'templates' ? this.tabs[1] : this.tabs[0];
            this.activeTab = groupToSet;
            this.editData = data;
        }
    },
    created () {
        this.getTemplateGroupsAsync();
        this.getAllTemplatesAsync();
        
        if(this.formats.length === 0) {
            this.getFormatsListAsync();
        }
        if(this.layouts.length === 0) {
            this.fetchLayoutsAsync();
        }
    }
};
</script>
